/**
 * Shared constants used across the application.
 */

/**
 * Tiny 10x10 gray blur placeholder for images (base64 encoded JPEG).
 * Used for blur-up loading effect before full image loads.
 */
export const BLUR_DATA_URL =
  "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMCwsKCwsNDhIQDQ4RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBT/wAARCAAKAAoDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABgcI/8QAIhAAAgIBAwQDAAAAAAAAAAAAAQIDBAUABhEHEiExQVFh/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwT/xAAaEQACAwEBAAAAAAAAAAAAAAABAgADESEx/9oADAMBAAIRAxEAPwCb7S6iZ/aWKgo4+OhJHWQqJLNVZpCPHLMx5J+vGiPT/r7ltzb0oZqrj6tfzwsEZVvH0SD7/dZtNViq1W7scSvyxPIB8e9GOnW2cZtzZ9OjiYfhiQku3y7n2xP2TobaYqiVYGf/2Q==";

/**
 * Default masonry grid breakpoint columns configuration.
 */
export const MASONRY_BREAKPOINTS = {
  default: 4,
  1100: 3,
  700: 2,
  500: 1,
};
